module.exports = __webpack_public_path__ + "img/03.81e9d42f.png";